import React, { useState, useEffect, useContext } from "react";
import {
  IonSearchbar,
  IonList,
  IonRadioGroup,
  IonItem,
  IonRadio,
  IonLabel,
  IonButton,
  IonPopover,
} from "@ionic/react";

import "./onCallSearchBy.scss";
import {
  ReturnDataModel,
  SearchByResponseModal,
} from "../../OnCallLookUpModel";
import { OnCallLookUpInputService } from "../../OnCalllookUpService";
import Loader from "../../../../components/Shared/Loader/Loader";
import { AddProviderContext } from "../../../StatusBoard/components/StatusBoardTable/components/ExpandedCard/components/SBoardProvider/SBoardProvider";
import { utilService } from "../../../../services/utilService";
import { CONSTANTS } from "../../../../constants/callcentral.constants";
import { statusBoardService } from "../../../StatusBoard/StatusBoard.service";
import { SupportStaffProviderContext } from "../../../StatusBoard/components/SupportStaff/SupportStaff";
import { onCallSearchResultService } from "../OnCallSearchResult/OnCallSearchResult.service";
import NoResults from "../../../../components/Shared/NoResults/NoResultsComponent";
import _ from "lodash";
import { dataTransferService } from "../../../../services/dataTransferService";
import { useNetwork } from "../../../../helpers/NetworkContext";
import { useTranslation } from "react-i18next";

interface onCallSearchByProps {
  selectedData: ReturnDataModel;
  getCancelAction: (cancelAction: boolean) => void;
  getOptionChangedAction: (optionChangedAction: boolean) => void;
  getOkAction: (returnData: string) => void;
  favCardData?: any;
  favFlag?:boolean;
  setFavFlag?:any;
}

const OnCallSearchByPage: React.FC<onCallSearchByProps> = (props) => {
  const { selectedNetwork } = useNetwork();
  const { t } = useTranslation("onCallLookup");

  const [searchText, setSearchText]: any = useState("");
  const [resultDataList, setResultDataList] = useState<Array<{}>>([]);
  const [selectedListItem, setSelectedListItem] = useState<string>("");
  const [isOptionSelected, setOptionSelected] = useState<boolean>(true);
  const [isBtnSelected, setBtnSelected]: any = useState(true);
  const [isLoaderActive, setLoaderStatus] = useState(false);
  const [isLargeScreen, setIsLargeScreen]: any = useState(true);
  const [favoriteCardData, setFavoriteData]: any = useState(true);
  const [searchEnabled, setSearchEnabled]: any = useState(true);
  const [showPopover, setShowPopover] = useState(false);
  const [popoverText, setPopoverText] = useState("");
  const [event, setEvent] = useState(null);
  const AddProviderContextData = useContext(
    statusBoardService.selectedProviderPoupType
      ? SupportStaffProviderContext
      : AddProviderContext
  );

  useEffect(() => {
    if (
      AddProviderContextData.popUptype ===
        CONSTANTS.PROVIDER_POPUPTYPE.PRIMARY_MD ||
      AddProviderContextData.popUptype === CONSTANTS.PROVIDER_POPUPTYPE.PROVIDER
    ) {
      const selectedData: ReturnDataModel = {
        DateSelected: utilService.getCurrentDate(),
        OptionSelected:
          AddProviderContextData.popUptype ===
          CONSTANTS.PROVIDER_POPUPTYPE.PRIMARY_MD
            ? "individual_provider"
            : "speciality",
        TimeSelected: utilService.getCurrentTime(),
        SiteSelected: statusBoardService.statusBoardData
          ? statusBoardService.statusBoardData[0].site?.siteId
          : "",
      };
      if (selectedData) {
        getResult(selectedData);
      }
    }
    checkIfLargeScreen();
  }, [selectedNetwork]);

  useEffect(() => {
    prepareComponent();
  }, [searchText]);

  useEffect(() => {
    dataTransferService.transferOnCallResultAction(true);
  }, [isBtnSelected]);

  useEffect(() => {
    var initialArray: any = [];
    setSearchText(_.cloneDeep(initialArray));
    dataTransferService.transferOnCallResultAction(false);
    setSelectedListItem("");
  }, [props.selectedData.SiteSelected, props.selectedData.OptionSelected]);

  const prepareComponent = () => {
    setResultDataList([]);
    if (!utilService.isEmpty(props.selectedData)) {
      getResult();
      setFavoriteData(props.favCardData);
    }
    setOptionSelected(true);
  };

  const handleLongPress = (event: any, itemName: any) => {
    setPopoverText(itemName);
    setEvent(event);
    setShowPopover(true);
  };

  const handleTouchEnd = () => {
    setShowPopover(false);
  };

  const getResult = async (selectedInputData?: any) => {
    setLoaderStatus(true);
    const params =
      AddProviderContextData.fromComponent === ""
        ? OnCallLookUpInputService.getParamsForSearchByComp(
            props.selectedData,
            searchText
          )
        : utilService.isEmpty(props.selectedData)
        ? OnCallLookUpInputService.getParamsForSearchByComp(
            selectedInputData,
            searchText
          )
        : OnCallLookUpInputService.getParamsForSearchByComp(
            props.selectedData,
            searchText
          );

   const respData: SearchByResponseModal =
  AddProviderContextData.fromComponent === ""
    ? await OnCallLookUpInputService.getSearchByResult(
        params,
        props.selectedData, // second param: searchParams
        selectedNetwork?.value  ??''    // third param: selectedNetwork
      )
    : utilService.isEmpty(props.selectedData)
    ? await OnCallLookUpInputService.getSearchByResult(
        params,
        selectedInputData,  // second param: searchParams
        selectedNetwork?.value??''
      )
    : await OnCallLookUpInputService.getSearchByResult(
        params,
        props.selectedData,
        selectedNetwork?.value??''
      );

    if (respData.isSuccess) {
      const displayData = respData.resultData ? respData.resultData.data : [];

      if (props.favCardData && searchEnabled) {
        let displayFavoriteList = props.favCardData;
        let indexResult = displayFavoriteListData(
          displayFavoriteList,
          displayData
        );

        const newData = moveItem(displayData, indexResult, 0);
        setResultDataList(newData);
      } else {
        setResultDataList(displayData);
      }

      if (!utilService.isEmpty(props.favCardData) && displayData.length > 0 && props?.favFlag) {
        setItemAsSelected();
      }
      onCallSearchResultService.setonCallSearchByListFromComponent(displayData);
    } else {
      console.log("error");
    }
    setLoaderStatus(false);
  }; 

  function moveItem(arr: any, fromIndex: any, toIndex: any) {
    let itemRemoved = arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, itemRemoved[0]);
    return arr;
  }

  const displayFavoriteListData = (
    displayFavoriteList: any,
    displayData: any
  ) => {
    const idSearch = getSearchByID(displayFavoriteList);
    let indexResult = displayData.findIndex(function (i: any) {
      return i.id === idSearch;
    });
    return indexResult;
  };

  const getSearchByID = (selectedOption: any) => {
    if (selectedOption.params.speciality) {
      const specilaityID = selectedOption
        ? selectedOption.params.speciality
        : "";
      return specilaityID;
    } else if (selectedOption.params.group_id) {
      const groupID = selectedOption ? selectedOption.params.group_id : "";
      return groupID;
    } else {
      const providerID = selectedOption
        ? selectedOption.params.nameParams.userid
        : "";
      return providerID;
    }
  };

  const getTitle = (option: string) => {
    switch (option) {
      case "group":
        return t("group", "Group");
      case "speciality":
        return t("specialty", "Specialty");
      case "individual_provider":
        return t("individualProvider", "Individual Provider");
    }
  };

  const getProviderList = (selectedValue: any) => {
    setSelectedListItem(selectedValue);
    if (AddProviderContextData.fromComponent !== "") {
      props.getOkAction(selectedValue);
    }
  };

  const setItemAsSelected = () => {
    if (!_.isEmpty(props.favCardData.params.nameParams.dr)) {
      setSelectedListItem(props.favCardData.params.guid);
      props.getOkAction(props.favCardData.params.guid);
    } else if (!_.isEmpty(props.favCardData.params.nameParams.group)) {
      setSelectedListItem(props.favCardData.params.group_id);
      props.getOkAction(props.favCardData.params.group_id);
    } else if (!_.isEmpty(props.favCardData.params.nameParams.speciality)) {
      setSelectedListItem(props.favCardData.params.speciality);
      props.getOkAction(props.favCardData.params.speciality);
    }
    setOptionSelected(false);
  };

  const checkIfLargeScreen = () => {
    if (utilService.getScreenSize() === "large") {
      setIsLargeScreen(true);
    } else {
      setIsLargeScreen(false);
    }
  };

  const handleSearch = (event: any) => {
    setSearchText(event.detail.value!);
  };

  return (
    <div className="ocl-searchby-res-component">
      {AddProviderContextData.fromComponent === "" && (
        <div className="ocl-text-title">
          <span>{getTitle(props.selectedData.OptionSelected!)}</span>
        </div>
      )}
      {AddProviderContextData.fromComponent !== "" && (
        <div className="ocl-text-title-provider-cont-add">
          <span className="title-option-selected">
            {getTitle(props.selectedData.OptionSelected!)}
          </span>
        </div>
      )}
      <div className="content-container">
        <div className="searchbar-container">
          <IonItem lines="none">
            <IonLabel>{t("search")}</IonLabel>
          </IonItem>
          <IonSearchbar
            className="search-input"
            debounce={0}
            value={searchText}
            onIonChange={(event: any) => {
              setSearchEnabled(false);
              handleSearch(event);
            }}
            placeholder={t("search")}
            type="search"
            clearIcon="never"
          ></IonSearchbar>
        </div>
        <div
          className={`list-container ${
            isLargeScreen && "list-container-large-screen"
          } `}
        >
          {isLoaderActive && (
            <div className="loader-container">
              <Loader></Loader>
            </div>
          )}
          <IonList lines="none">
            <IonRadioGroup
              onIonChange={(e) => {
                props.getOptionChangedAction(true);
                setOptionSelected(false);
                getProviderList(e.detail.value);
                if(props?.setFavFlag){
                  props?.setFavFlag(false)
                }
              }}
              value={selectedListItem}
            >
              {resultDataList && resultDataList.length > 0
                ? resultDataList.map((item: any) => {
                    return (
                      <div className="select-list-container" key={item?.id}>
                        <IonItem className="ion-item-group">
                          {props.selectedData.OptionSelected ===
                          "individual_provider" ? (
                            <IonRadio value={item?.guid}></IonRadio>
                          ) : (
                            <IonRadio value={item?.id.toString()}></IonRadio>
                          )}

                          <IonLabel
                            className={
                              selectedListItem === item?.id ||
                              selectedListItem === item?.guid
                                ? "selected-text-color"
                                : ""
                            }
                            onTouchStart={(e) => handleLongPress(e, item.name)}
                            onTouchEnd={() => handleTouchEnd()}
                          >
                            {item?.name}
                          </IonLabel>
                        </IonItem>
                      </div>
                    );
                  })
                : !isLoaderActive && (
                    <div className="no-results-label">
                      <NoResults></NoResults>
                    </div>
                  )}
            </IonRadioGroup>
          </IonList>

          <IonPopover
            isOpen={showPopover && !isLargeScreen}
            event={event}
            onDidDismiss={() => setShowPopover(false)}
          >
            <IonLabel className="popover-label">{popoverText}</IonLabel>
          </IonPopover>
        </div>
        {AddProviderContextData.fromComponent === "" && (
          <div className="button-container">
            <div className="">
              <IonButton
                color="medium"
                onClick={() => {
                  props.getCancelAction(true);
                }}
              >
                {t("cancel", "Cancel")}
              </IonButton>
            </div>
            <div className="active-btn-container">
              <IonButton
                onClick={() => {
                  props.getOkAction(selectedListItem);
                  setBtnSelected(!isBtnSelected);
                }}
                disabled={!selectedListItem || resultDataList.length === 0}
              >
                {t("ok", "Ok")}
              </IonButton>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OnCallSearchByPage;
